import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserTagFragmentDoc } from './UserTag';
import { SharedByWorkspaceFragmentDoc } from '../../../../../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/sharedByWorkspace';
import { IntegrationProviderLiteFragmentDoc } from '../../../../../../integrations/graphql/fragments/generated/IntegrationProviderLite';
export type UserTagWithIntegrationProviderFragment = { id: string, name: string, description?: string | null, availableOn: Array<Types.TagAvailableOnEnum>, type: Types.TagTypeEnum, subWorkspaces?: Array<string> | null, category?: Types.TagCategoryEnum | null, source?: string | null, subType?: Types.TagSubTypeEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { availableInLibrary: boolean, requiredTag: boolean, iconSettings: { type: Types.IconTypeEnum, value: string } }, createdBy?: { id: string, name?: string | null } | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null };


export type UserTagWithIntegrationProviderFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const UserTagWithIntegrationProviderFragmentDoc = /*#__PURE__*/ gql`
    fragment UserTagWithIntegrationProvider on UserTagType {
  ...UserTag
  integrationProvider {
    ...IntegrationProviderLite
  }
}
    `;